import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import React from 'react'
import BrandAgnosticFooter from 'src/components/BrandAgnosticFooter/BrandAgnosticFooter'
import BrandPrimaryLogo from 'src/components/BrandPrimaryLogo/BrandPrimaryLogo'
import UnauthedBox from 'src/components/UnauthedBox/UnauthedBox'
import { css, CSSProp } from 'styled-components'

interface UnauthedBoxContainerProps {
  className?: string
  topRightImage?: React.ReactElement
  bottomLeftImage?: React.ReactElement
  footer?: React.ReactElement
  hideBrandLogo?: boolean
  hideFooter?: boolean
  noInnerPadding?: boolean
  noBox?: boolean
  boxStyling?: CSSProp
}

const UnauthedBoxContainer: React.FC<
  React.PropsWithChildren<UnauthedBoxContainerProps>
> = (props) => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 100vh;
      width: 100%;
      padding: 120px 0px;

      ${getBreakpointDown(breakpointSizes.XSM)(css`
        padding: 40px 10px;
      `)}
    `}
    className={props.className}
  >
    {!props.hideBrandLogo && (
      <BrandPrimaryLogo
        css={css`
          margin-bottom: 40px;
          max-height: 100px;
          min-height: 25px;
          max-width: 140px;
          display: block;
          z-index: 1;

          ${getBreakpointDown(breakpointSizes.MD)(css`
            display: block;
          `)}
        `}
      />
    )}
    {props.noBox ? (
      <>{props.children}</>
    ) : (
      <UnauthedBox
        topRightImage={props.topRightImage}
        bottomLeftImage={props.bottomLeftImage}
        noInnerPadding
        boxStyling={props.boxStyling}
      >
        {props.children}
      </UnauthedBox>
    )}
    {!props.hideFooter && (props.footer || <BrandAgnosticFooter />)}
  </div>
)

export default UnauthedBoxContainer
